import { makeStyles } from '@material-ui/core';
import { getLargeDrawerPaperStyles } from 'UI/constants/styles';

export const useStyles = makeStyles(theme => ({
  drawerLarge: {
    ...getLargeDrawerPaperStyles(theme),
    overflowY: 'hidden'
  },
  drawerContent: {
    padding: ({ isFeedbackLogView }) => (isFeedbackLogView ? 0 : theme.spacing(2.5)),
    flexGrow: 1,
    overflowY: 'auto'
  }
}));
